import { ListIcon } from "../onboardingSections/inputs";

export const CustomWarning = ({
  children,
  text = "Fraud Prevention Information",
}) => (
  <div className="max-w-[460px] mx-auto flex flex-col gap-2.5">
    <ListIcon text={text} />
    {children}
  </div>
);
